import { makeStyles } from '@material-ui/styles';

const useTableStyles = makeStyles((theme) => ({
  root: {
    maxHeight: 'calc(100vh - 307px)',
  },
  content: {
    padding: 0,
  },
  inner: {},
  nameCell: {
    display: 'flex',
    alignItems: 'center',
  },
  isArchived: { backgroundColor: theme.palette.background.lightRed },

  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1),
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  tableCell: {
    paddingLeft: 20,
  },
  tableCellSmall: {
    width: 75,
    paddingLeft: 20,
  },
  hiddenMedium: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  hiddenSmall: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  hiddenXSmall: {
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  visibleSmall: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}));

export default useTableStyles;
